import { createAsyncThunk } from '@reduxjs/toolkit'
import WatchingProfileMetric from './watching-profile-metric-model'
import {
  delete_watchingProfileMetric,
  load_watchingProfileMetrics,
  store_watchingProfileMetric,
} from './watchingProfileMetric-service'

export const LoadWatchingProfileMetricsAsync = createAsyncThunk<any, any>(
  'composer/load/watchingProfileMetric',
  async (params: { uid: string }) => {
    return await load_watchingProfileMetrics(params)
  },
)

export const CreateWatchingProfileMetricAsync = createAsyncThunk<any, any>(
  'composer/create/watchingProfileMetric',
  async (params: WatchingProfileMetric) => {
    return await store_watchingProfileMetric(params)
  },
)

export const DeleteWatchingProfileMetricAsync = createAsyncThunk<any, any>(
  'composer/delete/watchingProfileMetric',
  async (params) => {
    return await delete_watchingProfileMetric(params)
  },
)
